const EnvironmentNames = {
  LOCALHOST: "localhost",
  DEV: "dev",
  LIVE: "live"
} as const;

export default EnvironmentNames;
